// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1ouVM","errorLogs":"EditorFooter_errorLogs__3dETg"};